import httpClient from "./_httpClient";

const getAllStatus = () => httpClient.get('/commandActivityLogsAllStatus/');

export {
  getAllStatus
}
